import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import AppBar from "./AppBar";
import { useHistory } from "react-router-dom";

function TOS() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const inapp = params.get("inapp") || false;

  const history = useHistory();

  const [loaded, setLoaded] = useState(false);

  let url = "https://help.gesture.vip/m-ica-terms-of-use/";

  useEffect(() => {
    setLoaded(true);
  }, []);
  return (
    <div style={{ width: "100%", overflowY: "hidden" }}>
      {!loaded ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "45vh",
          }}
        >
          <ClipLoader size={100} color="#2B08A0" />
        </div>
      ) : (
        <>
          <AppBar
            onClickAction={() => {
              history.goBack(`?inapp=${inapp}`);
            }}
            title={"Terms of Use"}
          />

          <iframe
            title="Terms of Use"
            src={url}
            width="100%"
            style={{ border: "none", overflow: "auto", height: "90%" }}
          ></iframe>
        </>
      )}
    </div>
  );
}

export default TOS;
